module.exports = __webpack_public_path__ + "static/img/unit5.5dd09e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unit5.png
// module id = Rsuj
// module chunks = 1